export const ROUTES = {
  ROOT: "/",
  CUSTOMER_DETAILS: "/customers/:customerId",
  /*
   * The share link. Keyed by the session id itself: a separate join code meant a
   * second identifier to keep unique, a lookup before the session could be
   * opened, and two things that could disagree about which session a link meant.
   */
  JOIN: "/join/:sessionId",
  SESSION: "/session/:sessionId",
  /*
   * The four destinations the nav reaches beside Customers. All facilitator-only
   * and all built on reads that already exist — `listSessionsForFacilitator` for
   * three of them, static deck content for the fourth — so none of them needed a
   * new query or a rules change.
   */
  SESSIONS: "/sessions",
  DECK: "/deck",
  /**
   * Same deck, no facilitator gate: static content, no Firestore read, so a
   * link works for anyone, loka.com or not.
   */
  DECK_PREVIEW: "/preview",
  REPORTS: "/reports",
  ARCHIVE: "/archive",
  /** The same Debrief the wrap round renders, opened on its own. */
  REPORT: "/reports/:sessionId",
}
